var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnToolParameter_1;
/* eslint-disable no-template-curly-in-string */
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ToolParameter, ToolParameterType, ToolParameterValueType } from './toolParameter';
import { ColumnTypeEnum } from './columnType';
const schema = {
    $id: 'urn:wisepipe-base-pipe:ColumnToolParameter',
    type: 'object',
    properties: {
        strVal: { type: 'string' },
        columnTypes: {
            type: 'array',
            items: { type: 'string', enum: Object.values(ColumnTypeEnum) },
            uniqueItems: true
        }
    },
    required: ['strVal', 'columnTypes']
};
// can't extend stringtoolparameter because of how we declare static Pipe/Global/Reusable
let ColumnToolParameter = ColumnToolParameter_1 = class ColumnToolParameter extends ToolParameter {
    constructor(name, type, value, columnTypes, description, pipeID = '') {
        super(name, type, ToolParameterValueType.COLUMN, description, pipeID);
        this.strVal = value;
        this.columnTypes = columnTypes;
        JSON.validate(this, ColumnToolParameter_1);
    }
    get value() {
        return this.strVal;
    }
    static Pipe(name, value, columnTypes, pipeID, description) {
        return new ColumnToolParameter_1(name, ToolParameterType.PIPE, value, columnTypes, description, pipeID);
    }
    static Global(name, value, columnTypes, description) {
        return new ColumnToolParameter_1(name, ToolParameterType.GLOBAL, value, columnTypes, description);
    }
    static Reusable(name, value, columnTypes, description) {
        return new ColumnToolParameter_1(name, ToolParameterType.REUSABLE, value, columnTypes, description);
    }
};
ColumnToolParameter = ColumnToolParameter_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolParameterValueType.COLUMN)
], ColumnToolParameter);
export { ColumnToolParameter };
//# sourceMappingURL=columnToolParameter.js.map